import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const PersonStatusValues = ["ACTIVE", "OUT_OF_OFFICE"] as const;
/**
 * Use this if you need to zod parse it
 */
export const PersonStatusSchema = z.enum(PersonStatusValues);
/**
 * Use this if you need to use the literal value
 */
export const PersonStatus = PersonStatusSchema.enum;
/**
 * Use this if you need to use the type
 */
export type PersonStatus = z.infer<typeof PersonStatusSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const PersonStatusDisplayNames: Record<PersonStatus, string> = {
  ACTIVE: "Active",
  OUT_OF_OFFICE: "Out of Office",
} as const;
